import axios from "axios";
import { keycloak } from "../keycloak";
import { AccountantResponseDTO, FindAllAccountantFiltersDTO, FindAllAccountants } from "./dto";
import { AccountantService } from "./service";

export class AccountantServiceImpl implements AccountantService {

    public findAllAccountant(filters: FindAllAccountantFiltersDTO): Promise<FindAllAccountants> {
        let url: string = "/api/accountants?" +
            "page=" + filters.page +
            "&itemsPerPage=" + filters.itemsPerPage +
            (filters.accountant !== '' ? '&accountant=' + filters.accountant : '') +
            (filters.financialAdvisor !== '' ? '&financialAdvisor=' + filters.financialAdvisor : '') +
            (filters.allofall !== false ? '&allofall=' + filters.allofall : '')
        return axios({
            url: url,
            method: "GET",
            headers: {
                Authorization: 'Bearer ' + keycloak.token,
                Accept: '*/*',
                ContentType: 'application/json',
                "Access-Control-Allow-Headers": "accept, authorization, content-type, x-requested-with",
                "Access-Control-Allow-Origin": "http://localhost:3000",
                "Access-Control-Allow-Methods": "GET",
            }
        }).then((response) => response.data)
    }

    public createAccountant(request: FormData): Promise<void> {
        let url: string = "/api/accountants"
        return axios({
            url: url,
            method: "POST",
            data: request,
            headers: {
                Authorization: 'Bearer ' + keycloak.token,
                Accept: '*/*',
                ContentType: 'application/json',
                "Access-Control-Allow-Headers": "accept, authorization, content-type, x-requested-with",
                "Access-Control-Allow-Origin": "http://localhost:3000",
                "Access-Control-Allow-Methods": "GET",
            }
        }).then((response) => response.data)
    }

    public findAccountant(id: string): Promise<AccountantResponseDTO> {
        let url: string = "/api/accountants/" + (window.location.pathname.split('edit-accountant/')[1] === undefined ? id : window.location.pathname.split('edit-accountant/')[1])
        return axios({
            url: url,
            method: "GET",
            headers: {
                Authorization: 'Bearer ' + keycloak.token,
                Accept: '*/*',
                ContentType: 'application/json',
                "Access-Control-Allow-Headers": "accept, authorization, content-type, x-requested-with",
                "Access-Control-Allow-Origin": "http://localhost:3000",
                "Access-Control-Allow-Methods": "GET",
            }
        }).then((response) => response.data)
    }

    public editAccountant(id: string, data: FormData): Promise<void> {
        let url: string = "/api/accountants/" + (window.location.pathname.split('edit-accountant/')[1] === undefined ? id : window.location.pathname.split('edit-accountant/')[1])
        return axios({
            url: url,
            method: "PUT",
            data: data,
            headers: {
                Authorization: 'Bearer ' + keycloak.token,
                Accept: '*/*',
                ContentType: 'application/json',
                "Access-Control-Allow-Headers": "accept, authorization, content-type, x-requested-with",
                "Access-Control-Allow-Origin": "http://localhost:3000",
                "Access-Control-Allow-Methods": "GET",
            }
        }).then((response) => response.data)
    }

    public deleteAccountant(id: string): Promise<void> {
        let url: string = "/api/accountants/" + id
        return axios({
            url: url,
            method: "DELETE",
            headers: {
                Authorization: 'Bearer ' + keycloak.token,
                Accept: '*/*',
                ContentType: 'application/json',
                "Access-Control-Allow-Headers": "accept, authorization, content-type, x-requested-with",
                "Access-Control-Allow-Origin": "http://localhost:3000",
                "Access-Control-Allow-Methods": "GET",
            }
        }).then(() => undefined)
    }
}
